'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceAirplanemodeActive = function DeviceAirplanemodeActive(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10.18 9' }),
    _react2.default.createElement('path', { d: 'M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z' })
  );
};
DeviceAirplanemodeActive = (0, _pure2.default)(DeviceAirplanemodeActive);
DeviceAirplanemodeActive.displayName = 'DeviceAirplanemodeActive';
DeviceAirplanemodeActive.muiName = 'SvgIcon';

exports.default = DeviceAirplanemodeActive;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/device/airplanemode-active.js
 ** module id = 1815
 ** module chunks = 0
 **/